/* src/app/shared/contract/contract-seller-list/contract-seller-grid/contract-seller-grid.component.scss */
.main-container-wrapper {
  background-color: #FFF;
  padding: 5px;
}
.main-container {
  background-color: #001A33;
  border-radius: 20px;
  padding: 15px;
  display: flex;
  flex-direction: column;
  min-height: calc(100vh - 10px);
  align-items: stretch;
  width: 100%;
}
.title {
  font: 700 18px FranceTV Brown;
  color: #DFEBF7;
}
.ids-filter-container {
  background-color: #1F364D;
  border-radius: 16px;
  margin-bottom: 15px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding: 25px 25px 2px;
}
.filter-container {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
.spinner-container {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 5px;
}
.small-icon {
  width: 15px;
  height: 15px;
  font-size: 15px;
  margin-right: 5px;
}
.padding-margin {
  padding-right: 10px;
  margin-top: 15px;
}
.light-flex-card {
  background-color: #FFF;
  border-radius: 16px;
  padding: 20px;
  padding: 20px;
}
.placeholder-light-flex-card {
  background-color: #FFF;
  border-radius: 16px;
  padding: 20px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.light-flex-card > p {
  color: #001A33;
}
.selected {
  background-color: rgba(223, 235, 247, 0.4);
}
.font-ns {
  font: 700 14px FranceTV Brown;
  color: #001A33;
}
.mat-cell {
  color: rgba(0, 26, 51, 0.8);
}
.mat-cell,
.mat-header-cell {
  padding: 5px;
  text-align: center;
}
.header-cell-center-align > ::ng-deep .mat-sort-header-container {
  justify-content: center;
  text-align: center;
}
.custom-header .mat-header-cell {
  border-bottom: 1px solid #DFEBF7;
  color: #001A33;
  text-align: center;
}
.custom-header-checkbox,
.custom-checkbox-cell {
  padding-left: 5px !important;
  padding-right: 5px !important;
  text-align: center;
}
.custom-header-checkbox ::ng-deep .mat-mdc-checkbox,
.custom-checkbox-cell ::ng-deep .mat-mdc-checkbox,
.custom-header-checkbox ::ng-deep .mat-checkbox,
.custom-checkbox-cell ::ng-deep .mat-checkbox {
  display: inline-flex;
  vertical-align: middle;
}
.search-and-buttons-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #DFEBF7;
  padding-bottom: 15px;
}
.buttons-container {
  display: flex;
  align-items: center;
}
.margin-left-10 {
  margin-left: 10px;
}
.margin-left-auto {
  margin-left: auto;
}
.screen-info-container {
  width: 100%;
}
.vertical-separator {
  height: 1px;
  background-color: #DFEBF7;
  margin-top: 20px;
  margin-right: -10px;
  width: 40px;
  transform: rotate(-90deg);
  align-self: stretch;
}
.search-and-switch-container {
  display: flex;
  align-items: center;
}
.billboard-div {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  padding-left: 10px;
}
.h4-label {
  color: #244666;
  font: 400 14px FranceTV Brown;
  padding-top: 3px;
  padding-right: 10px;
}
/*# sourceMappingURL=contract-seller-grid.component.css.map */
